import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import {AsReportedSecurity} from "../../../../../api/models/as-reported-security";
import {SecurityMappingService} from "../../../../../api/services/security-mapping.service";
import {ConfirmationService, MessageService} from "primeng/api";
import {MappingFilter} from "../../../../../api/models/mapping-filter";
import {
  handlePasteWithoutLeadingSpaces,
  preventLeadingSpaceKey
} from "../../../../../core/utils/input-validation.utils";

@Component({
  selector: 'app-multiple-security-types',
  standalone: false,
  templateUrl: './multiple-security-types.component.html',
  styleUrl: './multiple-security-types.component.css'
})
export class MultipleSecurityTypesComponent implements OnChanges{
  @Input() isActive: boolean = false;
  private hasLoadedOnce = false;
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["isActive"]?.currentValue === true) {
      this.hasLoadedOnce = false;
    }
  }
  ref!: DynamicDialogRef;
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  processedSecurity: AsReportedSecurity[] = [];
  selectedIssuers: any[] = [];
  selectedDialogRow: any = null;

  // Pagination for Security
  first = 0;
  rows = 10;
  searchBySecurityType?: string;
  issuerName?: string;
  isLoading: boolean = false;

  constructor(
    private _securityMappingService: SecurityMappingService,
    public dialogService: DialogService,
    private _messageService: MessageService,
    public confirmationService: ConfirmationService
  ) {}

  ngOnInit(): void {}
  getIssuerWithMultipleSecurityTypes() {
    const params: MappingFilter = {
      searchByName: this.issuerName,
      searchBySecurityType: this.searchBySecurityType,

      pageNumber: this.paginator.pageNumber,
      pageSize: this.paginator.pageSize,
      status: "ISSUER_WITH_MULTIPLE_SECURITY_TYPES",
    };
    this.isLoading = true;
    this._securityMappingService.getSecurityMapping(params).subscribe({
      next: (value) => {
        this.processedSecurity = value.IssuerWithMultipleSecurityTypes ?? [];
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.processedSecurity?.[0]?.totalCount ?? 0;
        this.isLoading = false;
      },
    });
  }
  loadData(event: any) {
    if (!this.isActive) return;
    if (!this.hasLoadedOnce && event.first === 0) {
      this.hasLoadedOnce = true;
    } else if (!this.hasLoadedOnce) {
      return;
    }

    if (event.first > 0 && this.paginator.pageSize !== event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }

    this.paginator.pageSize = event.rows;
    this.getIssuerWithMultipleSecurityTypes();
  }
  onSearch() {
    // Trim string filters before searching
    this.issuerName = this.issuerName?.trim() || undefined;
    this.searchBySecurityType = this.searchBySecurityType?.trim() || undefined;

    this.first = 0;
    this.paginator.pageNumber = 1;
    this.getIssuerWithMultipleSecurityTypes();
  }

  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  preventSpaceKey(event: KeyboardEvent): void {
    preventLeadingSpaceKey(event);
  }

  onPaste(
    event: ClipboardEvent,
    field: "issuerName" | "searchBySecurityType"
  ): void {
    handlePasteWithoutLeadingSpaces(event, (newValue: string) => {
      this[field] = newValue;
    });
  }

}
